import React from "react";
import "./WireLayer.scss";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators as widgetConfigActions } from "../../../../actions/widgetConfigActions";
import { actionCreators as uiActionCreators } from "../../../../actions/uiActions";

import {
  deviceSelector,
  resolvedSensorConfigSelector,
  resolvedDataConfigSelector,
} from "../../../../selectors";

import WireLine from "./WireLine";

import { positionFromGridCoords } from "../../../../helpers/grid";
import { GRID_SIZE, colors } from "../../../../helpers/constants";

class WireLayer extends React.PureComponent {
  componentDidMount() {
    this._widgets_container_el = document.getElementById("_widgets_container");
    this._devicebar_container_el = document.getElementById("_devicebar_items");
  }

  render() {
    let {
      hoveredWidgetId,
      hoveredWidgetConfig,
      hoveredSensor,
      setHoveredWidget,
      disconnectWidgetFromSensor
    } = this.props;

    if (
      (!hoveredWidgetConfig ||
        !hoveredWidgetConfig.sensor_slots[0] ||
        !hoveredWidgetConfig.sensor_slots[0].sensorid) &&
      !hoveredSensor
    ) {
      return null;
    }

    let sensorInfos = [{ x: 0, y: 0 }],
      sensorInfo = sensorInfos[0],
      widgetPositions = [];

    let lineProps = [];
    // Either a sensor, or a widget is selected
    if (hoveredWidgetId) {
      // Hovered Widget (later extend to arrays, mimo) 1 widget - n sensors
      ({ sensorInfos, widgetPositions } = this.handleHoveredWidget());
      //console.log("V1", hoveredWidgetConfig);
      lineProps = sensorInfos.map((_sensorInfo, idx) => {
        let widgetPosition = widgetPositions[idx];
        return {
          startx: _sensorInfo.x,
          starty: _sensorInfo.y,
          endx: widgetPosition.x,
          endy: widgetPosition.y,
          lineColor: _sensorInfo.color,
          circleColor: _sensorInfo.color,
          sensorid: _sensorInfo.sensorid,
          widgetid: hoveredWidgetId
        };
      });
    } else if (!!hoveredSensor) {
      // Hovered Sensor (later extend to arrays, mimo) 1 sensor - widgets
      ({ sensorInfo, widgetPositions } = this.handleHoveredSensor());

      lineProps = widgetPositions.map(_widgetPosition => {
        return {
          startx: sensorInfo.x,
          starty: sensorInfo.y,
          endx: _widgetPosition.x,
          endy: _widgetPosition.y,
          lineColor: sensorInfo.color,
          circleColor: sensorInfo.color
        };
      });
    }

    return (
      <div className="wirelayer">
        <svg height="100%" width="100%">
          {lineProps.map((lineProp, idx) => (
            <WireLine
              {...lineProp}
              key={idx}
              onMouseEnter={() => {
                setHoveredWidget(hoveredWidgetId);
              }}
              onMouseLeave={() => {
                setHoveredWidget(false);
              }}
              onRemoveConnection={(w, s) => {
                disconnectWidgetFromSensor(w, s);
              }}
            />
          ))}
        </svg>
      </div>
    );
  }

  sensorInfoForSensor(deviceid, sensorid) {
    let sensorEl = document.getElementById(sensorid);

    if (!sensorEl) {
      return { x: 0, y: 0, sensorid };
    }

    let sensorElBBox = sensorEl.getBoundingClientRect();

    // Get sensorColors
     let colorForSensor = "black";
    //  device aus deviceid mit deviceselector
    //      resolvedsensorconfig, resolveddeviceconfig
    //      -> colors, evtl. mit eigenem selector. 

    // find the sensor color for the connected sensor. 
    // if none use device color. if none use fallback blue.
    let device = deviceSelector(this.props.devices, deviceid);
    let resolvedSensorConfig = resolvedSensorConfigSelector(device, sensorid);
    let resolvedDataConfig = resolvedDataConfigSelector(device);
    if (
      resolvedSensorConfig &&
      resolvedSensorConfig.color &&
      resolvedSensorConfig.color.value
    ) {
      colorForSensor = resolvedSensorConfig.color.value;
    } else if (resolvedDataConfig && resolvedDataConfig.color) {
      colorForSensor = resolvedDataConfig.color;
    } else {
      colorForSensor = colors["selected"];
    }

    //

    return {
      x: sensorElBBox.left + sensorElBBox.width / 2,
      y: sensorElBBox.top + sensorElBBox.height - 0,
      color: colorForSensor,
      sensorid
    };
  }

  handleHoveredWidget() {
    let { hoveredWidgetConfig } = this.props;
    // get source position (sensor element of devicebar item)
    let sensorInfos = [];
    let widgetPositions = [];
    if (
      hoveredWidgetConfig &&
      hoveredWidgetConfig.hasOwnProperty("sensor_slots") &&
      hoveredWidgetConfig.sensor_slots.length > 0
    ) {
      // This is true for all widgets
      let { gridCoords } = hoveredWidgetConfig;

      // get position of the x center and top edge of the widget element
      let widgetOrigin_raw = positionFromGridCoords(
        {
          gridx:
            gridCoords.gridx1 + (gridCoords.gridx2 - gridCoords.gridx1) / 2,
          gridy: gridCoords.gridy1
        },
        GRID_SIZE
      );
      let widgetContainerBBox = this._widgets_container_el.getBoundingClientRect();

      // Iterate over sensor slots
      for (let i = 0; i < hoveredWidgetConfig.sensor_slots.length; i++) {
        // SENSORS POSITIONS

        const sensorSlot = hoveredWidgetConfig.sensor_slots[i];

        if (!sensorSlot || !sensorSlot.deviceid || !sensorSlot.sensorid) {
          continue;
        }
        let connectedSensorId = sensorSlot.sensorid;
        let connectedDeviceId = sensorSlot.deviceid;

        let sensorInfo = this.sensorInfoForSensor(connectedDeviceId, connectedSensorId);

        if (!sensorInfo) {
          sensorInfo = { x: 0, y: 0 };
        }
        // If widget position exceeds devicebar because of scrolling, cap the x-pos to devicebar start/end
        let devicebarElBBox = this._devicebar_container_el.getBoundingClientRect();
        if (sensorInfo.x < devicebarElBBox.x) {
          sensorInfo.x = devicebarElBBox.x - 10;
        } else if (sensorInfo.x > devicebarElBBox.x + devicebarElBBox.width) {
          sensorInfo.x = devicebarElBBox.x + devicebarElBBox.width + 10;
        }
        sensorInfos.push(sensorInfo);

        // WIDGET POSITIONS
        // offset with the widget container element AND x-offset with gutter between endpoints

        let widgetPosition = {
          x:
            widgetOrigin_raw.x +
            widgetContainerBBox.left +
            widgetPositions.length * 25,
          y: widgetOrigin_raw.y + widgetContainerBBox.top + 2
        };
        widgetPositions.push(widgetPosition);
      }
      // make wires not to cross as possible
      sensorInfos.sort((a, b) => b.x - a.x);
      widgetPositions.sort((a, b) => b.x - a.x);
      // center array of widget endpoints
      let centerOffset =
        (widgetPositions[widgetPositions.length - 1].x - widgetPositions[0].x) /
        2;
      widgetPositions.forEach(position => {
        position.x += centerOffset;
      });
    }

    return { widgetPositions, sensorInfos };
  }

  handleHoveredSensor() {
    let { hoveredSensor, widgetsConnectedToHoveredSensor } = this.props;

    if (widgetsConnectedToHoveredSensor.length < 1) {
      return;
    }
    // One sensor position
    let sensorInfo = this.sensorInfoForSensor(hoveredSensor.deviceid, hoveredSensor.sensorid);

    // Potentially multiple widget positions. One for now
    let widgetPositions = [];
    for (const key in widgetsConnectedToHoveredSensor) {
      if (widgetsConnectedToHoveredSensor.hasOwnProperty(key)) {
        const connectedWidgetConfig = widgetsConnectedToHoveredSensor[key];

        let { gridCoords } = connectedWidgetConfig;

        // get position of the x center and top edge of the widget element
        let widgetOrigin_raw = positionFromGridCoords(
          {
            gridx:
              gridCoords.gridx1 + (gridCoords.gridx2 - gridCoords.gridx1) / 2,
            gridy: gridCoords.gridy1
          },
          GRID_SIZE
        );
        let widgetContainerBBox = this._widgets_container_el.getBoundingClientRect();

        // offset with the widget container element
        let widgetPosition = {
          x: widgetOrigin_raw.x + widgetContainerBBox.left,
          y: widgetOrigin_raw.y + widgetContainerBBox.top + 2
        };

        widgetPositions.push(widgetPosition);
      }
    }

    return { widgetPositions, sensorInfo: sensorInfo };
  }
}

const mapStateToProps = state => {
  let hoveredWidgetId = state.ui.hoveredWidget;
  let hoveredWidgetConfig = hoveredWidgetId
    ? state.widgetConfig[hoveredWidgetId]
    : undefined;
  let hoveredSensor = state.ui.hoveredSensor;
  let widgetsConnectedToHoveredSensor = hoveredSensor ? widgetsConnectedToSensor(
    state,
    hoveredSensor
  ) : null;

  return {
    hoveredWidgetId: hoveredWidgetId,
    hoveredWidgetConfig: hoveredWidgetConfig,
    hoveredSensor: hoveredSensor,
    widgetsConnectedToHoveredSensor,
    devices: state.devices
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { ...uiActionCreators, ...widgetConfigActions },
    dispatch
  );
}

const ConnectedWireLayer = connect(
  mapStateToProps,
  mapDispatchToProps
)(WireLayer);

export default ConnectedWireLayer;

function widgetsConnectedToSensor(state, sensor) {

  let {sensorid: _sensorId} = sensor;
  let widgetConfigs = {};
  if (
    !state &&
    !state.widgetConfig &&
    Object.keys(state.widgetConfig).length < 1
  ) {
    return null;
  }
  const { widgetConfig } = state;

  // Traverse all widgets
  for (const widgetId in widgetConfig) {
    if (widgetConfig.hasOwnProperty(widgetId)) {
      const widget = widgetConfig[widgetId];

      // Traverse sensor slots
      if (widget.hasOwnProperty("sensor_slots")) {
        widget.sensor_slots.forEach(sensor_slot => {
          if (
            sensor_slot.hasOwnProperty("sensorid") &&
            sensor_slot.sensorid === _sensorId
          ) {
            widgetConfigs[widgetId] = widget;
          }
        });
      } else {
        return null;
      }
    }
  }

  return widgetConfigs;
}
